import { createMuiTheme } from '@material-ui/core/styles'
import { red } from '@material-ui/core/colors'

// Create a theme instance.
const theme = createMuiTheme({
  spacing: 8,
  typography: {
    h1: {
      fontSize: 34,
      letterSpacing: 0.25,
      fontFamily: 'Roboto',
      fontWeight: 'normal',
    },
  },
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fafafa',
    },
  },
})

export default theme
